import { render } from "./ClassificationIndex.vue?vue&type=template&id=16303503&scoped=true"
import script from "./ClassificationIndex.vue?vue&type=script&lang=js"
export * from "./ClassificationIndex.vue?vue&type=script&lang=js"

import "./ClassificationIndex.vue?vue&type=style&index=0&id=16303503&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16303503"]])

export default __exports__